/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Architect_Detail9Inputs */

const en_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data model, auth and UI skeleton in days.`)
};

const ar_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نموذج البيانات والمصادقة وهيكل الواجهة في أيام.`)
};

const bn_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দিনের মধ্যে ডেটা মডেল, অথ আর UI কঙ্কাল।`)
};

const de_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenmodell, Auth und UI-Skelett in Tagen.`)
};

const es_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de datos, autenticación y esqueleto de interfaz en días.`)
};

const fr_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle de données, authentification et squelette d'interface en quelques jours.`)
};

const pt_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo de dados, autenticação e esqueleto de interface em dias.`)
};

const zh_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`几天内搞定数据模型、登录和界面骨架。`)
};

const tr_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günler içinde veri modeli, kimlik doğrulama ve arayüz iskeleti.`)
};

const ru_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель данных, авторизация и скелет интерфейса за дни.`)
};

const pl_svc_mvp_sprint_architect_detail9 = /** @type {(inputs: Svc_Mvp_Sprint_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model danych, logowanie i szkielet interfejsu w dni.`)
};

/**
* | output |
* | --- |
* | "Data model, auth and UI skeleton in days." |
*
* @param {Svc_Mvp_Sprint_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_architect_detail9 = /** @type {((inputs?: Svc_Mvp_Sprint_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "de") return de_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "es") return es_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_architect_detail9(inputs)
	return en_svc_mvp_sprint_architect_detail9(inputs)
});
export { svc_mvp_sprint_architect_detail9 as "svc_mvp-sprint_ARCHITECT_detail" }